import { clamp } from "./chunk-KROBAS26.js";

// src/components/Stepper/Stepper.Edge.tsx
import React, { forwardRef } from "react";
import { clsx } from "clsx";
var DEFAULT_COMPONENT = "div";
var STEPPER_EDGE_CLASSNAME_MAP = {
  variant: {
    default: "pd-stepper__edge--default",
    primary: "pd-stepper__edge--primary",
    disabled: "pd-stepper__edge--disabled",
    success: "pd-stepper__edge--success"
  }
};
var StepperEdge = forwardRef((_ref, ref) => {
  let {
    as,
    variant = "default",
    weight = 1,
    progress = 1,
    className
  } = _ref;
  const Component = as || DEFAULT_COMPONENT;
  const normalizedProgress = clamp(progress, 0, 1);
  return /* @__PURE__ */React.createElement(Component, {
    role: "meter",
    "aria-valuemin": 0,
    "aria-valuemax": 1,
    "aria-valuenow": normalizedProgress,
    ref,
    className: clsx("pd-stepper__edge", STEPPER_EDGE_CLASSNAME_MAP.variant[variant], className),
    style: {
      flexGrow: weight,
      ["--pd-stepper-edge-progress"]: clamp(normalizedProgress, 0, 1)
    }
  });
});
var Stepper_Edge_default = StepperEdge;
export { Stepper_Edge_default };